import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { ServerResponseSchema } from 'app'
import type { MatchSchema } from 'match'

export interface FetchAction {
  id: string
}

const getInitialState = () =>
  serverResponse<MatchSchema[]>({
    data: [],
  })

const match = reduxFetchCreator<
  'matchFetch',
  FetchAction,
  ReturnType<typeof getInitialState>,
  ServerResponseSchema<MatchSchema[]>
>('matchFetch', getInitialState(), {
  start: (state, action) => ({
    ...state,
    key: action.payload.id,
  }),
})

const matchFetchEpic = epicRequest({
  actionType: match.actions.matchFetch,
  errorAction: match.actions.matchFetchError,
  fulfilledAction: match.actions.matchFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.id}`,
  untilTypes: match.actions.matchFetchCancel,
})

export const epics = [matchFetchEpic]

export const actions = {
  ...match.actions,
}

export const reducer = reducersMerge(match.reducer)
